import ChartJS from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

ChartJS.register(ChartDataLabels);

export default function DayChart({
    month, // 'YYYY-MM'
    fullDayKeys, // ['YYYY-MM-DD', ...]
    counts, // number[]
    minRel,
    yAxisMax,
    onSelect, // (dayKey|null) => void
}) {
    if (!month) return null;

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        onClick: (_evt, elements) => {
            if (elements.length > 0) {
                const idx = elements[0].index;
                onSelect(fullDayKeys[idx]); // YYYY-MM-DD
            } else {
                onSelect(null);
            }
        },
        plugins: {
            datalabels: {
                anchor: "end",
                align: "end",
                offset: 0,
                formatter: (v) => v,
                font: { weight: "bold" },
            },
            title: {
                display: true,
                // text: `Daily Lead Counts for ${month} (rel ≥ ${minRel}%)`,
                text: `Daily Lead Counts for ${month}`,
                font: { weight: "bold" },
                padding: { top: 4, bottom: 20 },
            },
            legend: { display: false },
            tooltip: {
                callbacks: {
                    title: (items) => `Day ${items?.[0]?.label || ""}`,
                    label: (item) => `Count: ${item.raw ?? 0}`,
                },
            },
        },
        scales: {
            x: {
                title: { display: true, text: "Day" },
                ticks: { maxRotation: 0, autoSkip: true },
                grid: { color: "rgba(148, 163, 184, 0.25)" },
            },
            y: {
                title: { display: true, text: "Lead count" },
                beginAtZero: true,
                max: yAxisMax,
                ticks: { precision: 0 },
                grid: { color: "rgba(148, 163, 184, 0.25)" },
            },
        },
    };

    // Match MonthChart palette (slate-900)
    const data = {
        labels: fullDayKeys.map((k) => k.slice(8, 10)), // DD
        datasets: [
            {
                // label: `New leads (rel ≥ ${minRel}%)`,
                label: `New leads`,
                data: counts,
                backgroundColor: "rgba(15, 23, 42, 0.85)", // slate-900
                borderRadius: 10,
                borderSkipped: false,
                hoverBackgroundColor: "rgba(15, 23, 42, 0.95)",
            },
        ],
    };

    return (
        <div className="w-full">
            <div className="w-full rounded-2xl border border-slate-200 bg-white p-3 sm:p-4 shadow-sm">
                <div className="h-56 sm:h-72 md:h-96 lg:h-[420px]">
                    <Bar data={data} options={options} />
                </div>

                <div className="mt-3 flex items-center justify-between gap-3 text-xs sm:text-sm text-slate-600">
                    <div className="truncate">
                        Click a bar to drill down. Click empty space to clear.
                    </div>
                    {/* keep prop in place; UI-only */}
                    <div className="shrink-0 hidden sm:block">
                        Relevance ≥ <span className="font-semibold text-slate-800">{minRel}%</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
